import React, { useCallback, useEffect, useState } from "react";
import { api, errorMessage } from "../../lib/api";
import { toast } from "sonner";
import { Download } from "lucide-react";

export default function WaitlistPanel() {
  const [data, setData] = useState({ total: 0, entries: [] });
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/waitlist");
      setData(data);
    } catch (err) { toast.error(errorMessage(err)); } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const exportCsv = async () => {
    try {
      const res = await api.get("/admin/waitlist/export", { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url; a.download = "waitlist.csv"; a.click();
      window.URL.revokeObjectURL(url);
      toast.success("CSV downloaded");
    } catch (err) { toast.error(errorMessage(err)); }
  };

  return (
    <div className="space-y-5" data-testid="waitlist-panel">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="label-mono">Pre-launch & post-edition signups</div>
          <h2 className="font-display text-3xl text-white mt-1">
            <span className="text-brand" data-testid="waitlist-total">{data.total}</span> {data.total === 1 ? "signup" : "signups"}
          </h2>
        </div>
        <button
          onClick={exportCsv}
          disabled={data.total === 0}
          className="btn-secondary flex items-center gap-2"
          data-testid="waitlist-export-csv"
        >
          <Download className="w-4 h-4" /> Export CSV
        </button>
      </div>

      <div className="card-surface overflow-x-auto" data-testid="waitlist-table">
        {loading ? (
          <div className="text-center py-10"><span className="spinner" /></div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="label-mono text-left border-b border-white/10">
                <th className="py-3 pr-4">Email</th>
                <th className="py-3 pr-4">Edition</th>
                <th className="py-3 pr-4">Signed up</th>
              </tr>
            </thead>
            <tbody>
              {data.entries.map((e, i) => (
                <tr key={`${e.email}-${e.edition_name}`} className="border-b border-white/5 hover:bg-white/[0.02]" data-testid={`waitlist-row-${i}`}>
                  <td className="py-3 pr-4 text-white">{e.email}</td>
                  <td className="py-3 pr-4 text-gray-400">{e.edition_name}</td>
                  <td className="py-3 pr-4 text-gray-500 font-mono text-xs">{new Date(e.signed_up_at).toLocaleString()}</td>
                </tr>
              ))}
              {data.entries.length === 0 && (
                <tr><td colSpan={3} className="text-center text-gray-500 py-8">No waitlist signups yet.</td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
